<template>
  <div class="modal_json">
    <h4 class="title">
      {{ translate("device_models.modal_header", {device_sku: device_sku}) }}
    </h4>

    <pre>
      {{ JSON.parse(data) }}
    </pre>
    <div class="text-center">
      <button
          type="submit"
          class="btn btn-danger btn-fill btn-wd marginButton"
          @click.prevent="cancel"
      >
        Close
      </button>
    </div>
  </div>

</template>
<script>

export default {
  name: "ShowTestConfig",
  props: ["data", "device_sku"],
  data () {
    return {
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
  }
}

</script>

<style lang='scss'>
.modal_json{
  padding: 10px;
  .title{
    margin: 0 0 10px;
    text-align: center;
  }
  pre{
    max-height: 500px
  }
}

</style>
